import axios from "axios";
import { getAccessToken, getRefreshToken, setTokens, clearTokens } from "./auth";
import { backendbaseUrl } from "./baseUrl";
const API_BASE_URL = backendbaseUrl;

// No default "Content-Type" here: axios sets application/json for plain objects,
// and for FormData the browser must set multipart/form-data with its own boundary
// (a forced JSON header can break file uploads on iOS Safari).
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

// Add JWT Token to each request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle Token Expiry
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // error.response is undefined on network errors (Safari "Load failed",
    // CORS failures, 502/504 without CORS headers, timeouts). Use optional chaining.
    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refresh = getRefreshToken();
        if (!refresh) {
          throw new Error("Refresh token missing");
        }

        const response = await axios.post(`${API_BASE_URL}/api/token/refresh/`, {
          refresh,
        });

        const newAccessToken = response.data.access;
        setTokens(newAccessToken, refresh); // Store new token
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest); // Retry original request
      } catch (refreshError) {
        clearTokens();
        window.location.href = "/login"; // Redirect to login
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;